import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-vote_button_loading_light",
  "use": "icon-vote_button_loading_light-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-vote_button_loading_light\"><path fill=\"#FF81CD\" d=\"M4.1 1.737a4.667 4.667 0 1 1-2.767 4.266V5.52a.583.583 0 1 0-1.166 0v.483A5.834 5.834 0 1 0 3.626.672.583.583 0 0 0 4.1 1.737Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol